import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Assuming you're using TypeScript, define the type for the root element
const rootElement = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);
root.render(<App />);

// Unregister service worker to prevent stale cache issues after deploys
serviceWorkerRegistration.unregister();

